import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import CustomerInitiativeForm from 'modules/maya/components/CustomerInitiativeForm/CustomerInitiativeForm';
import Heading from 'modules/maya/components/Heading';
import MayaLayout from 'modules/maya/components/MayaLayout';
import useCiTemplateCreate from 'modules/maya/routes/CiTemplateCreate/CiTemplateCreate.hook';
import Box from 'yoda-ui/Box';
import Loader from 'yoda-ui/Loader';

const CiTemplateCreate: FC = () => {
  const { t } = useTranslation();
  const {
    loading,
    parentStrategicImperative,
    handleSaveCustomerInitiativeForm,
    handleCancelCustomerInitiativeForm,
  } = useCiTemplateCreate();

  return (
    <MayaLayout>
      <Heading>
        { t('maya_ci_tpl_form_title') }
      </Heading>

      {
        loading
          ? (

            <Box display="flex" flexDirection="column" justifyContent="center" height="100%">
              <Loader center />
            </Box>
          )
          : (
            <CustomerInitiativeForm {
              ...{
                parentStrategicImperative,
                submitCallback: handleSaveCustomerInitiativeForm,
                cancelCallback: handleCancelCustomerInitiativeForm,
              }
            } />
          )
      }
    </MayaLayout>
  );
};

export default CiTemplateCreate;
